import { render, staticRenderFns } from "./reslist.vue?vue&type=template&id=33d47084&scoped=true&"
import script from "./reslist.vue?vue&type=script&lang=js&"
export * from "./reslist.vue?vue&type=script&lang=js&"
import style0 from "./reslist.vue?vue&type=style&index=0&id=33d47084&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d47084",
  null
  
)

export default component.exports